import { render, staticRenderFns } from "./ValidationView.vue?vue&type=template&id=a0cc55be&"
import script from "./ValidationView.vue?vue&type=script&lang=js&"
export * from "./ValidationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports